import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 45px;
  background: #ffffff;
  width: 100%;
  margin: 0 100px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const Title = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 33px;
  color: #151515;
  margin: 12px 0px;
`;

export const Description = styled.p`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 23px;
  color: #151515;
`;

export const SignIn = styled.div`
  cursor: pointer;
  text-decoration: underline;
  :hover {
    font-weight: bold;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: ${({ checkbox }) => (checkbox ? "row" : "column")};
  flex: 1;
  width: ${({ checkbox }) => (checkbox ? "auto" : "100%")};
  margin: 20px 25px 0 0;
  :last-child {
    margin-right: 0;
  }
  background: ${({ checkbox }) => (checkbox ? "#f9f9f9" : "none")};
  border: ${({ checkbox }) => (checkbox ? "1px solid #d1d1d1" : "none")};
  border-radius: 12px;
  padding: ${({ checkbox }) => (checkbox ? "9px 16px" : "none")};
`;

Form.Input = styled.input`
  background: #f9f9f9;
  width: 100%;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 9px 16px;
  :hover {
    border-color: #7ed321 !important;
  }
  :focus {
    border: 1.5px solid #7ed321 !important;
  }
  outline: none;
`;

export const Checkbox = styled.input`
  width: 20px;
  border: 1.5px solid #d1d1d1;
  box-sizing: border-box;
  height: 20px;
  outline: none;
  background: #f9f9f9;
  margin-right: 10px;
  transition: all 0.5s ease;
  cursor: pointer;

  :checked {
    background-color: MediumSeaGreen;
    border-color: MediumSeaGreen;
    color: #fff;
  }
`;
Form.Label = styled.label`
  font-family: Poppins;
  font-style: normal;
  line-height: 18px;
  color: #151515;
  font-weight: ${({ save }) => (save ? "normal" : "600")};
  font-size: ${({ save }) => (save ? "14px" : "12px")};
`;
export const Textarea = styled.textarea`
  width: 100%;
  background: #f9f9f9;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 12px;
  outline: none;
  box-sizing: border-box;
  color: #a9a9a9;
  padding: 11px 16px 0px 21px;
  :hover {
    border-color: #7ed321 !important;
  }
  :focus {
    color: black !important;
  }
`;
export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(126, 211, 33);
  border: 1px solid rgb(126, 211, 33);
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  font-family: "SF Pro Display";
  transition-duration: 0.4s;
  width: 150px;
  margin: 25px 0 10px 0;
  height: 36px;
  & path {
    stroke: #ffffff;
  }
  &:hover {
    background-color: white; /* Green */
    color: rgb(126, 211, 33);
    & path {
      stroke: rgb(126, 211, 33);
    }
  }
  &:active {
    box-shadow: rgb(126, 211, 33) 0px 3px 10px;
    transform: scale(0.95);
  }
`;
